import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

export interface ActionDialogProps {
    open: boolean;
    title: string;
    text: string;
    onNo: () => void;
    onYes: () => void;
}

const ActionDialog = ({open, title, text, onNo, onYes}: ActionDialogProps) => {
    const [t] = useTranslation();

    if (!open)
        return null;

    return <div className="ActionDialog">
        <div className="dialogContainer">
            <div className="textContent">
                <div className="title">{title}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: text}} />
            </div>
            <div className="buttons">
                <div className="button yes" onClick={onYes}>{t("yes")}</div>
                <div className="button no" onClick={onNo}>{t("no")}</div>
            </div>
        </div>
    </div>
}

export default ActionDialog;